import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavigationHeader } from '../../../components/UploadNavHeader';
import { NavigationHeaderCopyLinkBlock } from '../NavigationHeaderCopyLinkBlock';

const BUILD_REPORTS = 'Build reports';
const ALL_REPORTS = 'All reports';
const SHARED_REPORTS = 'Shared reports';

const TABS = [BUILD_REPORTS, ALL_REPORTS, SHARED_REPORTS];

const ROUTES_MAP = {
  [BUILD_REPORTS]: '/report-manager/build-reports',
  [ALL_REPORTS]: '/report-manager/all-reports',
  [SHARED_REPORTS]: '/report-manager/shared-reports',
};

export const NavigationWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState<string>(
    Object.keys(ROUTES_MAP).find(
      (tabName) =>
        ROUTES_MAP[tabName as keyof typeof ROUTES_MAP] === location.pathname
    ) || BUILD_REPORTS
  );

  const handleOnTabClick = (tab: string) => {
    if (selectedTab !== tab) {
      setSelectedTab(tab);
      navigate(ROUTES_MAP[tab as keyof typeof ROUTES_MAP]);
    }
  };

  return (
    <NavigationHeader
      tabs={TABS}
      selectedTab={selectedTab}
      onTabClick={handleOnTabClick}
      secondaryContent={<NavigationHeaderCopyLinkBlock />}
    />
  );
};
